var Model = require("../../../types/Model.js");
var log = require("../../../../utils/BluetoothLog").logState;
var ReactNative = require("react-native");
const { Platform  } = ReactNative;

var READ_TIMEOUT = 1500;

module.exports = new Model({
	name: "deviceA&DBloodPressure",
	listeners: listeners,
	triggers: triggers,
	init: init,
	uninit: uninit,

	handleProgressUpdated: handleProgressUpdated,
	handleBatteryReading: handleBatteryReading,
	handleFinishReading: handleFinishReading,
	disconnect: disconnect,
	clean: clean,
});

function init() {
	this._isListening = false;
	this._isRead = false;
	this._deviceMac = null;

	this._progress = 0;

	this._batteryReadings = [];
	this._readings = [];

	this._readTimeout = null;
}

function uninit() {
	this._isListening = false;
	this._isRead = false;
	this._deviceMac = null;

	this._progress = 0;

	this._batteryReadings = [];
	this._readings = [];

	clearTimeout(this._readTimeout);
	this._readTimeout = null;
}

function triggers() {
	return {
		"info": info,
		"ready": ready,
		"clean": clean,
		"disconnect": disconnect,
		"failed": failed
	};
}

function listeners() {
	return {
		"bluetooth:event": handleEvent,
	};
}

function info(){
	var trigger = "devicebloodpressure:trigger:begin";
	var message = "myhealthdevice.a&dbpprepmessage";

	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.prepare_blood_pressure",
		items: {
			prepare: {
				message: message,
				type: "confirmcancel",
				trigger: trigger,
				cancelTrigger: "myhealthdevice:trigger:clean",
				pair: "myhealthdevice:trigger:pair"
			}
		}
	});

	this.emit("usermetrics:trigger:track", "open read from device modal for blood pressure", {
		"device type": "A&D Blood Pressure",
	});
}

function ready(data){
	this._deviceMac = data.mac;
	this._isListening = true;

	this.emit("bluetooth:trigger:read", {
		service: "DEVICE_BATTERY_SERVICE",
		characteristic: "DEVICE_BATTERY_CHARACTERISTIC",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:listen", {
		service: "ANDBP_SERVICE",
		characteristic: "ANDBP_READ_CHARACTERISTIC",
		device: this._deviceMac
	});
	// log(this, "BPA&DReady", this);
}

function handleEvent(event){
	var isListening = this._isListening;
	var readings = this._readings;

	var char = event.characteristic;
	if(!isListening) return;

	var data = event.data;

	this._isRead = true;

	// log(this, "BPA&DEvent", this);
	if(char === "ANDBP_READ_CHARACTERISTIC"){
		this._readings = readings.concat(data);
		clearTimeout(this._readTimeout);
		this._readTimeout = setTimeout(handleFinishReading.bind(this), READ_TIMEOUT);
	} else if(char === "DEVICE_BATTERY_CHARACTERISTIC"){
		this._batteryReadings = [].concat(data);
		this.handleBatteryReading();
	}
	this.handleProgressUpdated();
}

function handleProgressUpdated(){
	var progress = this._progress;

	if(progress < 2)
		progress++;

	this.emit("feedbackmodal:trigger:update", {
		reading: {
			type: "progress",
			message: "myhealthdevice.reading",
			progress: progress / 2,
			cancelTrigger: "myhealthdevice:trigger:clean"
		}
	});

	this._progress = progress;
}

function handleFinishReading(){
	var readings = this._readings;
	var isRead = this._isRead;
	if(!isRead) return;

	var reading = formatReading(readings);
	if(!reading) return;

	// log(this, "BPA&FinishReading", this);
	this.dispatch("done", reading);
	this.disconnect();
}

function disconnect(){
	var isListening = this._isListening;

	if(isListening){
		this._isListening = false;
		this.emit("bluetooth:trigger:listen:stop", {
			service: "ANDBP_SERVICE",
			characteristic: "ANDBP_READ_CHARACTERISTIC",
			device: this._deviceMac
		});
	}
	// log(this, "BPA&DDisconnect", this);
}

function failed(){
	const message = Platform.OS === "ios" ? "myhealthdevice.failed_iOS" : "myhealthdevice.failed";
	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.failedtitle",
		items: {
			continue: {
				message: message,
				type: "confirmcancel",
				trigger: "myhealthdevice:trigger:begin",
				cancelTrigger: "myhealthdevice:trigger:clean",
				pair: "myhealthdevice:trigger:pair"
			}
		}
	});
	// log(this, "BPA&DFailed", this);
}

function clean(){
	this._isListening = false;
	this._isRead = false;
	this._deviceMac = null;
	this._progress = 0;

	this._readings = [];
	this._batteryReadings = [];

	clearTimeout(this._readTimeout);
	this._readTimeout = null;
	// log(this, "BPA&DCleaned", this);
}

function handleBatteryReading(){
	var readings = this._batteryReadings;
	var reading = formatBatteryReading(readings);
	this.dispatch("battery", reading);
}

function formatReading(readings) {
	var latestReading = readings[readings.length - 1];
	var systolic = latestReading[1];
	var diastolic = latestReading[3];
	var bpPulserate = latestReading[7];
	if (systolic === 255 || diastolic === 255) return false;
	else return {
		systolic: systolic,
		diastolic: diastolic,
		bpPulserate: bpPulserate
	};
}

function formatBatteryReading(readings){
	var latestReading = readings[readings.length - 1];
	return latestReading[0];
}